module.exports = __webpack_public_path__ + "img/es-rounded.69bf7c3d.png";